"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useModeDocs = exports.updateWindowStyles = exports.modeStyles = exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _themeDark = _interopRequireDefault(require("./theme-dark"));
var _jsxRuntime = require("react/jsx-runtime");
var _div; // default localstorage ID
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var STORAGE_ID_DEFAULT = 'st-mode';
var modeStyles = {
  light: '',
  dark: _themeDark["default"]
};
exports.modeStyles = modeStyles;
var modeRegex = /^st-mode--[a-zA-Z]*$/;

/**
 * Detects the system color mode by reading prefers-color-scheme
 * and returns a string with either dark or light
 */
function getModeFromSystem() {
  if (window && window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    return 'dark';
  }
  return 'light';
}

/**
 * Reads the last saved mode from localStorage
 */
function getModeFromLocalStore() {
  var storageId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : STORAGE_ID_DEFAULT;
  try {
    return localStorage.getItem(storageId);
  } catch (_unused) {
    return null;
  }
}

/**
 *
 * @param {string} mode Name of mode
 * @param {string} storageId ID for localStorage
 *
 * Saves to localStorage
 */
function saveToStore(mode) {
  var storageId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : STORAGE_ID_DEFAULT;
  try {
    return localStorage.setItem(storageId, mode);
  } catch (_unused2) {
    return null;
  }
}

/**
 * Given a mode name, adds a mode-specific CSS class to <body>
 * And inserts a block of CSS into #st-mode-styleblock to set
 * values for the design tokens
 * @param {string} modeParam The mode name to apply styles for
 */
var updateWindowStyles = function updateWindowStyles(modeParam) {
  var modeName = modeParam;
  var modeDisplayedName = modeParam === 'auto' ? getModeFromSystem() : modeParam;

  // apply modes class list to body
  var body = document.querySelector('body');
  body.classList.toString().split(' ').forEach(function (className) {
    if (modeRegex.test(className)) body.classList.remove(className);
  });
  if (body.className.indexOf('st-mode') === -1) {
    body.classList.add('st-mode');
  }
  var updatedThemeName = "st-mode--".concat(modeDisplayedName);
  body.classList.add(updatedThemeName);
  var modeStyleBlock = document.getElementById('st-mode-styleblock');
  if (!modeStyleBlock) {
    document.head.insertAdjacentHTML('beforeend', "<style id=\"st-mode-styleblock\">".concat(modeStyles[modeName], "</style>"));
  } else {
    modeStyleBlock.innerText = modeStyles[modeName];
  }
};

/**
 * custom hook for uncontrolled version of Mode
 * for use in ThemeProvider
 * this allows users to set a starting mode with "defaultMode"
 * but any subsequent changes to that prop are ignored
 * in favor of whatever is in the internal state
 */
exports.updateWindowStyles = updateWindowStyles;
function useMode() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$defaultMode = _ref.defaultMode,
    defaultMode = _ref$defaultMode === void 0 ? 'auto' : _ref$defaultMode,
    storageId = _ref.storageId,
    getModeFromStore = _ref.getModeFromStore,
    setModeToStore = _ref.setModeToStore;
  var _useState = (0, _react.useState)(),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    modeSetting = _useState2[0],
    setModeSetting = _useState2[1];
  var _useState3 = (0, _react.useState)(),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    modeDisplayed = _useState4[0],
    setmodeDisplayed = _useState4[1];
  var refModeSetting = (0, _react.useRef)(modeSetting); // to prevent stale state in closure for userEffect

  (0, _react.useEffect)(function () {
    refModeSetting.current = modeSetting;
  });

  // for handling initial load and setting mode
  // if user has previously selected a mode and it's in localstore
  // then defer to that
  // otherwise use defaultMode
  // if defaultMode is auto, then detect from system
  // write all these to state and localstore
  /* eslint-disable react-hooks/exhaustive-deps */
  (0, _react.useEffect)(function () {
    var finalmode = '';
    var modeToDisplay = '';
    var modeFromStore = getModeFromStore && getModeFromStore() || getModeFromLocalStore(storageId);
    // console.log(`mode from store ${storageId} is ${modeFromStore}`);

    // if user has selected light or dark
    if (modeFromStore && modeFromStore !== 'auto') {
      finalmode = modeFromStore;
      modeToDisplay = modeFromStore;
    } else if (modeFromStore === 'auto' || !modeFromStore && defaultMode === 'auto') {
      // if user has selected auto, or user hasn't selected anything and defaultMode is auto
      finalmode = modeFromStore || defaultMode;
      modeToDisplay = getModeFromSystem();
    } else {
      // user hasn't selected anything, and defaultMode is not auto
      finalmode = defaultMode;
      modeToDisplay = defaultMode;
    }
    updateWindowStyles(modeToDisplay);
    if (setModeToStore) {
      setModeToStore(finalmode);
    } else {
      saveToStore(finalmode, storageId);
    }
    setModeSetting(finalmode);
    setmodeDisplayed(modeToDisplay);
  }, []);
  /* eslint-enable react-hooks/exhaustive-deps */

  var updateModeAndWindow = (0, _react.useCallback)(function (newmode) {
    // console.log(`updateModeAndWindow called: updating mode to ${newmode}`);
    var modeToDisplay = newmode === 'auto' ? getModeFromSystem() : newmode;
    updateWindowStyles(modeToDisplay);
    if (setModeToStore) {
      setModeToStore(newmode);
    } else {
      saveToStore(newmode, storageId);
    }
    setModeSetting(newmode);
    setmodeDisplayed(modeToDisplay);
  }, [storageId, setModeToStore]);

  // listen for changes to user's device mode
  // so we can change dark/light mode when user updates their device preference
  (0, _react.useEffect)(function () {
    function updateOnEventChange(event) {
      // console.log(`detected event change ${refModeSetting.current}`);
      if (refModeSetting.current === 'auto') {
        var newmode = event.matches ? 'dark' : 'light';
        updateWindowStyles(newmode);
        setmodeDisplayed(newmode);
        // console.log(`new mode is ${newmode}`);
      }
    }

    // older versions of iOS don't support matchMedia.addEventListener
    // once iOS 15 lands, go back to addEventListener('change', callback)
    // console.log('setting event listener for dark mode');
    window.matchMedia('(prefers-color-scheme: dark)').addListener(updateOnEventChange);
    return function () {
      return window.matchMedia('(prefers-color-scheme: dark)').removeListener(updateOnEventChange);
    };
  }, []);
  function toggleMode() {
    // toggle modeSetting, can't be used when in auto
    if (modeSetting !== 'auto') {
      // console.log(`toggle mode from ${mode}`);
      updateModeAndWindow(modeSetting === 'light' ? 'dark' : 'light');
    }
  }
  return {
    modeSetting: modeSetting,
    modeDisplayed: modeDisplayed,
    updateMode: updateModeAndWindow,
    updateWindowStyles: updateWindowStyles,
    toggleMode: toggleMode
  };
}
var useModeDocs = function useModeDocs() {
  return _div || (_div = /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    children: "placeholder for storybook"
  }));
};
exports.useModeDocs = useModeDocs;
process.env.NODE_ENV !== "production" ? useModeDocs.propTypes = {
  /** The current user setting for the color mode. */
  mode: _propTypes["default"].oneOf(['auto', 'light', 'dark']).isRequired,
  /** The color mode that is being displayed based on the user setting. */
  modeDisplayed: _propTypes["default"].oneOf(['light', 'dark']).isRequired,
  /** Updates the user setting to this specific modeSetting, and also updates the data store. */
  updateMode: _propTypes["default"].func.isRequired,
  /** Toggles the user setting for the mode. Only works if current setting is not `auto`. */
  toggleMode: _propTypes["default"].func.isRequired,
  /** Updates appearance of color mode without updating the data store. */
  updateWindowStyles: _propTypes["default"].func.isRequired
} : void 0;
var _default = useMode;
exports["default"] = _default;